import { useHasSimpleUserPrivileges } from 'hooks/useHasSimpleUserPrivileges';

interface Props {
  entityRefNo?: string | undefined;
  privilegeType: string;
  children: React.ReactNode;
}
/**
 * @see useHasSimpleUserPrivileges
 */

const HasSimpleUserPrivilege = ({ entityRefNo, privilegeType, children }: Props) => {
  const privileges = useHasSimpleUserPrivileges([privilegeType], entityRefNo);

  return privileges[privilegeType] ? <>{children}</> : <></>;
};

export default HasSimpleUserPrivilege;
